var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data && _vm.data != '-')?_c('li',[[_c('span',{staticClass:"font-weight-bold mr-3"},[_vm._v(_vm._s(_vm.label)+":")]),_vm._v(" "),_c('label',{staticClass:"expanded-items-label"},[_vm._v(_vm._s(_vm.data))])]],2):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7a254d6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./src/components/user/dashboard/pages/races/view-race/race-registration/table-item/table-item.html
// module id = null
// module chunks = 